import {
	GET_CLAIM_DETAILS,
	GET_CLAIM_DOCS,
	SET_CLAIM_DOCS_ERRORS,
	GET_CLAIM_EVENTS,
	SOLVE_CLAIM,
	AGREE_CLAIM,
	REJECT_CLAIM,
	RESET_STATE,
	SET_DOCS_FILES,
	SET_CLAIMS_FORM,
	GET_CLAIMS_FORM,
	SET_CLAIM_DETAILS,
	SET_CLAIM_DOCS,
	POST_CLAIM_DOCS,
	SET_CLAIM_EVENTS,
	SET_IS_LOADING,
	SET_IS_SENDING,
} from './actions';

export const initialState = {
	data: null,
	claimDocs: [],
	claimsForm: [],
	claimDocsFormErrors: {},
	claimEvents: '',
	isSolving: false,
	solveError: null,
	isAgreeing: false,
	agreeError: null,
	isRejecting: false,
	rejectError: null,
	isLoading: false,
	isSending: false,
	files: {},
};

const claimsDetailsModalReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case GET_CLAIM_DETAILS:
			return {
				...state,
				activeClaimId: payload.id,
			};
		case SET_CLAIM_DETAILS:
			return {
				...state,
				data: payload,
			};
		case GET_CLAIM_DOCS:
			return {
				...state,
				claimDocsFormErrors: {},
			};
		case SET_CLAIM_DOCS:
			return {
				...state,
				claimDocs: payload,
			};
		case POST_CLAIM_DOCS:
			return {
				...state,
			};
		case SET_CLAIM_DOCS_ERRORS:
			return {
				...state,
				claimDocsFormErrors: payload,
			};
		case SET_DOCS_FILES:
			return {
				...state,
				files: payload,
			};
		case GET_CLAIMS_FORM:
			return {
				...state,
			};
		case SET_CLAIMS_FORM:
			return {
				...state,
				claimsForm: payload,
			};
		case GET_CLAIM_EVENTS:
			return {
				...state,
				claimEventsError: null,
			};
		case SET_CLAIM_EVENTS:
			return {
				...state,
				claimEvents: payload,
			};
		case SOLVE_CLAIM:
			return {
				...state,
				isSolving: true,
				solveError: null,
			};
		case AGREE_CLAIM:
			return {
				...state,
				isAgreeing: true,
				agreeError: null,
			};
		case REJECT_CLAIM:
			return {
				...state,
				isRejecting: true,
				rejectError: null,
			};
		case SET_IS_LOADING:
			return {
				...state,
				isLoading: payload,
			};
		case SET_IS_SENDING:
			return {
				...state,
				isSending: payload,
			};
		case RESET_STATE:
			return {
				...initialState,
			};

		default:
			return state;
	}
};

export default claimsDetailsModalReducer;
